@use '~@frontrow/console/css/variables.scss';

@forward '~@frontrow/console/css/variables.scss';

.overview {
  border-radius: variables.$std-border-radius;
  border: variables.$base-border-width solid variables.$base-border-color;
  display: inline-block;
  margin: variables.$std-margin-md;
  padding: variables.$std-padding-md;
  width: 46%;
}
